import {SOPutRequirement} from '../../core/requirement/so-put-requirement';
import {RequirementCore} from './requirement.core';
import {SOGetRequirement} from '../../core/requirement/so-get-requirement';
import {FormField, SelectionOption} from 'lionheartland';
import {putRequirementFormFieldOptions} from './put-requirement-form-fields';
import {AdapterProtocol} from 'lionheartland';
import {BasePut} from 'lionheartland';
import {ProjectCore} from '../project/project.core';
import {SOGetProject} from '../../core/project/so-get-project';
import {OrganizationCore} from '../organization/organization.core';
import {SOGetOrganization} from '../../core/organization/so-get-organization';

export class RAPutRequirement extends BasePut implements AdapterProtocol {
  formFieldOptions = Object.values(putRequirementFormFieldOptions);

  RequestClass = SOPutRequirement

  constructor(
    public entityCore: RequirementCore
  ) {
    super();
    if (putRequirementFormFieldOptions.parent) {
      putRequirementFormFieldOptions.parent.makeCore = true;
    }
    if (putRequirementFormFieldOptions.project) {
      putRequirementFormFieldOptions.project.makeCore = true;
    }
  }

  onSet() {
    super.onSet()
  }

  prepareRequest() {
    this.request = new this.RequestClass(
      this.selectedEntity.uid,
      this.getFormValueFromIdentifier('name'),
      this.getFormValueFromIdentifier('description'),
      this.getFormValueFromIdentifier('active'),
      this.getFormValueFromIdentifier('currentStatus'),
      this.getFormValueFromIdentifier(
        'parent',
        SOGetRequirement,
      ),
      this.getFormValueFromIdentifier(
        'project',
        SOGetProject,
      ),
      this.getFormValueFromIdentifier(
        'organization',
        SOGetOrganization,
        true,
      ),
    )
  }


  onSelectionChange(field: FormField) {
    super.onSelectionChange(field)
  }

  fetchOptions(field: FormField) {
    super.fetchOptions(field)
  }

  getSelectionOption(field: FormField, entity): SelectionOption {
    return super.getSelectionOption(field, entity)
  }
}